import { useState } from 'react'
import { Typography } from '@material-ui/core'
import { observer } from 'mobx-react-lite'
import { useMutation } from 'react-query'
import { useDMEStore } from '../../store'
import createCustomerPhysicianDetails from '../../requests/createCustomerPhysicianDetails'
import useStyles from './styles'
import PhysicianForm from '../../forms/PhysicianSearchForm/PhysicianForm'
import { useLayout } from '../../widgets/Layout'

export interface PhysicianDetailsFormProps {
  nextAction: () => void
}

export default observer(({ nextAction }: PhysicianDetailsFormProps) => {
  const store = useDMEStore()
  const classes = useStyles()
  const [isLoading, setIsLoading] = useState(false)

  const [createPhysicianDetailsMutation] = useMutation(
    createCustomerPhysicianDetails,
    {
      onSuccess: nextAction,
      onError: nextAction,
    }
  )

  const layout = useLayout()

  const formStrategy = layout?.showPhysicianPhoneNumberTextField
    ? 'create'
    : 'search'

  const submitFunction = (data: any) => {
    const { firstName, lastName, stateName, city, phoneNumber } = data
    const searchInputs = { firstName, lastName, city }
    setIsLoading(true)
    store.physician.setSearchInput({
      ...searchInputs,
      stateName,
    })
    createPhysicianDetailsMutation({
      firstName,
      lastName,
      addressState: stateName,
      addressCity: city,
      phoneNumber,
    })
  }

  return (
    <>
      <Typography gutterBottom className={classes.disclaimer} variant="body1">
        {formStrategy === 'create'
          ? 'Check for typos. A phone number will help us reach out to your provider for a prescription.'
          : "Confirm your provider's information is correct and then continue to check out."}
      </Typography>
      <PhysicianForm
        buttonText="Check Out"
        isLoading={isLoading}
        strategy={formStrategy}
        submitFunction={submitFunction}
      />
      <Typography
        className={classes.emailNotice}
        color="textSecondary"
        component="p"
        variant="caption"
      >
        We will email you if we need more information.
      </Typography>
    </>
  )
})
